module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/499971232f47fdb5bf2f60ded2f0d119.png";